import React, { useState, useEffect } from 'react';
import '../PlanSelectorCarousel/style.scss';
import { useDispatch, useSelector } from 'react-redux';
import { clearWorkflowStart } from 'action-creators/payway/workflowStart';
import { getPurchaseButtonInfo } from 'action-creators/payway/purchaseButtonInfo';
import { checkIfProtectPaymentIsActive } from 'containers/EPG/actions/channelBlocker/blocker.actions';
import { pushGTMEvent } from 'containers/Player/utils/analytics';
import ClaroUrlBuilder from 'utils/ClaroUrlBuilder';
import { getActionPaymentLink } from 'containers/Vcard/utils/redirect';
import { PlanCard, PlanCarousel } from 'cvlib';
import { hideHeadband } from 'action-creators/headband';
import { showModalCommercial } from 'reducers/modalLandingCommercial/modalLandingCommercial.actions';
import { selectMetadataKeyByRegion } from '../../../../../../reducers/selectors/metadata';
import { pushPaymentEvent } from '../../../../../Payment/utils/metrics';
import { ReloadCarouselButton } from '../ReloadCarouselButton';
import { useGetPlanSelectorInfo } from '../../../../../../hooks/useGetPlanSelectorInfo';
import {
  setOfferSelector,
  setParamPaymentIsActive,
  setPaymentLink,
} from 'reducers/modalLandingCommercial/modalLandingCommercial.actions';
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';
import './styles.scss';

export const getParameterByName = (name, url) => {
  const newName = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${newName}(=([^&#]*)|&|#|$)`);

  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const offersTransformation = (offers, pbi) => {
  const newOffers = offers?.contentsList?.map(offer => {
    const pbiMach = pbi?.filter(p => p?.product_id === offer?.product_id);
    const dataPBI = pbiMach?.[0] || {};
    return {
      family: dataPBI?.family,
      oneoffertype: dataPBI?.oneoffertype,
      oneofferdesc: dataPBI?.oneofferdesc,
      offerid: dataPBI?.offerid,
      periodicity: dataPBI?.periodicity,
      ...offer,
    };
  });
  return newOffers;
};

// Carrusel de selector de planes en claro publicidad
const PlanOfferCarousel = ({
  title,
  node,
  hasError,
  handleReload,
  currentCarousel,
}) => {
  const dispatch = useDispatch();

  const [offers, setOffers] = useState([]);
  const pbi = useSelector(
    state => state.payway?.purchaseButtonInfo?.data?.listButtons?.button || [],
  );
  const claroLiteConfig = useSelector(
    selectMetadataKeyByRegion('cv_advertising_config'),
  );
  const location = useLocation();
  const navigate = useNavigate();
  const workflowStart = useSelector(state => state?.payway?.workflowStart);
  const user = useSelector(state => state.user);

  const [wfscleared, setWfscleared] = useState(false);
  const [whatContainsIsShowState, setWhatContainsIsShowState] = useState(false);
  const { offersSelect } = useSelector(state => state?.modalLandingCommercial);
  const [isClickSubcribe, setIsClickSubcribe] = useState(false);

  const {
    loadingPlans,
    handleCardClickWhatIncludes,
    planSelectorMetrics,
    getPlanSelectorOffers,
  } = useGetPlanSelectorInfo();
  const isFreemiumUserNotLogged =
    user.userType === 'ANONYMOUS' && claroLiteConfig?.enable;

  useEffect(() => {
    dispatch(clearWorkflowStart());
    setWfscleared(true);
  }, []);

  useEffect(
    () => {
      if (!location.state?.whatContainsIsShown || !whatContainsIsShowState) {
        getPlanSelectorOffers();
      }
    },
    [location.state?.whatContainsIsShown, whatContainsIsShowState],
  );

  useEffect(
    () => {
      if (pbi?.length) {
        setOffers(offersTransformation(currentCarousel, pbi));
      }
    },
    [pbi, currentCarousel],
  );

  useEffect(
    () => {
      if (workflowStart.inProgress === false && wfscleared !== false) {
        const link = getActionPaymentLink({
          userType: user.userType,
          claroAdEnabled: claroLiteConfig?.enable,
        });
        const groupId = location?.state?.groupId;

        let params = {};

        if (groupId && groupId !== undefined)
          params.player_url = ClaroUrlBuilder.player(groupId);

        if (workflowStart.success) {
          if (user.userType === 'ANONYMOUS') {
            if (groupId && groupId !== undefined) {
              params.groupId = groupId;
            }
            params = {
              ...params,
              oneoffertype: offersSelect?.producttype,
              oneofferdesc: offersSelect?.oneofferdesc,
              linkworkflowstart: offersSelect?._links?.checkout?.href,
            };
          }

          const isBuyRentContent =
            offersSelect?.oneoffertype === 'download_rent' ||
            offersSelect?.oneoffertype === 'rent' ||
            offersSelect?.oneoffertype === 'download_buy';

          if (isFreemiumUserNotLogged) {
            params.anonymousUser = 'true';
            localStorage.setItem('object_id', offersSelect?.product_id);
            if (isBuyRentContent) {
              params.isBuyRentContent = 'true';
              localStorage.removeItem('object_id');
            }
          }

          dispatch(setPaymentLink(link));
          dispatch(setParamPaymentIsActive(params));

          if (isClickSubcribe) {
            dispatch(
              checkIfProtectPaymentIsActive({
                onSuccess: () =>
                  navigate({
                    pathname: link,
                    search: `?${createSearchParams(params)}`,
                    state: {
                      screen:
                        getParameterByName(
                          'selected_payment_method',
                          offersSelect?._links?.checkout?.href,
                        ) === 'promogate'
                          ? 'promogate'
                          : 'checkout',
                    },
                  }),
              }),
            );
          }
        }
      }
    },
    [workflowStart.inProgress],
  );

  const pushBeginCheckoutEvent = plan => {
    const gtmEventInfo = {
      event: 'begin_checkout',
      item_id: plan?.offerid,
      item_name: plan?.producttype.toLowerCase(),
      item_category: 'canal tv',
      item_category_2: 'no aplica',
      item_category_3:
        plan?.oneoffertype === 'subscrition'
          ? `por suscripcion${
              plan?.family === 'clarovideo' ? '' : ` ${plan?.family}`
            }`
          : '',
      item_category_4: 'no aplica',
      item_brand: plan?.family,
      item_list_name: 'home inicio',
      price: plan?.price,
      quantity: '1',
    };
    pushGTMEvent(gtmEventInfo);
  };

  const handleOnWhatIncludes = plan => {
    dispatch(setPaymentLink(''));
    dispatch(setOfferSelector(plan));
    dispatch(showModalCommercial(true));
    pushBeginCheckoutEvent(plan);
    dispatch(hideHeadband());
    setIsClickSubcribe(false);
    navigate(location.pathname, {
      query: location.search,
      state: {
        ...location.state,
        whatContainsIsShown: true,
        planClicked: plan,
      },
      replace: true,
    });
    setWhatContainsIsShowState(true);
    pushPaymentEvent(
      // metricas
      'selecciona tu plan - home',
      'home',
      'seleccion de plan',
      `${plan?.translation?.btnSuscription?.texts?.[0]?.text} - ${
        plan?.translation?.btnFeatures?.texts?.[0]?.text
      }`,
    );
    planSelectorMetrics(plan);
  };

  const handleCardClick = plan => e => {
    e.stopPropagation();
    setIsClickSubcribe(true);
    dispatch(setOfferSelector(plan));
    handleCardClickWhatIncludes(plan);
  };

  const getBackground = plan => {
    return (
      plan?.assets?.background?.['230x491'] || plan?.assets?.background?.default
    );
  };

  if (!loadingPlans && !offers?.length) return null;

  return (
    <>
      {hasError ? (
        <ReloadCarouselButton handleReload={handleReload} />
      ) : (
        <PlanCarousel
          id="plan-selector__carousel"
          className="plan-selector__carousel"
          title={title}
          isHome={
            node === 'homeuser_lite' ||
            node === 'homeuser' ||
            node === 'homeuser_kids'
          }
        >
          {offers?.map(plan => (
            <PlanCard
              key={plan?.product_id}
              image={getBackground(plan)}
              logo={plan?.assets?.logo?.web}
              currency={plan?.price?.currency}
              price={plan?.price?.amount}
              temporality={plan?.translation?.labelTemporality}
              taxText={plan?.translation?.labelTaxes}
              promotionText1={plan?.translation?.txtPromo?.texts?.text1}
              promotionText2={plan?.translation?.txtPromo?.texts?.text2}
              promotionText3={plan?.translation?.txtPromo?.texts?.text3}
              whatIncludesColor={plan?.translation?.btnFeatures?.fgColor}
              onWhatIncludesClicked={() => handleOnWhatIncludes(plan)}
              whatIncludesText1={plan?.translation?.btnFeatures?.texts?.text1}
              whatIncludesText2={plan?.translation?.btnFeatures?.texts?.text2}
              contractButtonColor={plan?.translation?.btnSuscription?.fgColor}
              onContractClicked={handleCardClick(plan)}
              contractText1={plan?.translation?.btnSuscription?.texts?.text1}
              contractText1color={
                plan?.translation?.btnSuscription?.texts?.color1
              }
              contractText2={plan?.translation?.btnSuscription?.texts?.text2}
              contractText2color={
                plan?.translation?.btnSuscription?.texts?.color2
              }
              className={'plan-selector__card'}
            />
          ))}
        </PlanCarousel>
      )}
    </>
  );
};

export default PlanOfferCarousel;
